export const shipmentFilterNameGroupTitle = 'Name';
export const shipmentFilterSelectIntegrationsTitle = 'Carriers (Optional)';
export const shipmentFilterSelectStatesTitle = 'Shipment states/events';
export const shipmentFilterShipmentTypeTitle = 'Shipment types';
export const shipmentFilterShipmentTagsTitle = 'Shipment tags (Optional)';
export const shipmentFilterExpiryTitle = 'Expiry (Optional)';
export const shipmentFilterRestrictTriggerTitle = 'Restrict Trigger (Optional)';
export const shipmentFilterSmartFilterTitle = 'Smart Filter Settings (Optional)';

export const editApiKeyTitle = 'Rename your API Key';

export const sftpAccountFormTitle = 'Create an SFTP Account';
export const createSftpAccountTitle = 'Creating an SFTP Account';
export const okButtonTitle = 'Got it';
